export const getLocalizedText = (item: { name: string; name_es?: string }, lang: string) => {
  if (lang === "es" && item.name_es) return item.name_es;
  return item.name;
};

export const getLocalizedCollectionName = (
  item: { name: string; name_es?: string },
  lang: string
) => {
  if (lang === "es" && item.name_es) return item.name_es;
  return item.name;
};

export const getLocalizedCollectionDesc = (
  item: { description?: string; description_es?: string },
  lang: string
) => {
  if (lang === "es" && item.description_es) return item.description_es;
  return item.description || "";
};
